import { gql } from '@apollo/client'

const DUPLICATE_BRAND_CURATION_TASK_MUTATION = gql`
  mutation duplicateBrandCurationTaskMutation($id: ID!, $customName: String) {
    duplicateBrandCurationTask(id: $id, customName: $customName) {
      id
      brand {
        id
        name
      }
    }
  }
`

export default DUPLICATE_BRAND_CURATION_TASK_MUTATION
